var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.invalFlg)?_c('h1',[_vm._v("停止中")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }